<template>
	<section>
		<h3>Activity Log</h3>

		<button v-if="!showActivityLog" v-on:click="showActivityLog = true" class="btn btn-light">
			<i class="fa fa-list"></i>
			Show Activity Log
		</button>

		<button v-else v-on:click="showActivityLog = false" class="btn btn-light">
			<i class="fa fa-eye-slash"></i>
			Hide Activity Log
		</button>

		<template v-if="showActivityLog">
			<ul v-if="activityLog.length > 0" class="list-group mt-2">
				<li v-for="(log, logIndex) in activityLog" class="list-group-item">
					<div class="d-flex flex-row">
						<div style="width: 195px;">
							<i class="fa fa-fw" :class="log.icon"></i>
							{{ formatDateTimeToLocal(log.datetime) }}:
						</div>
						<div class="pl-4">
							{{ log.message }}
							
							<div v-if="detailIndex == logIndex && detailsVisible">
								<template v-if="typeof log.details == 'string'">{{log.details}}</template>
								<ul v-else-if="typeof log.details == 'object'">
									<li v-for="item in log.details">{{item}}</li>
								</ul>
							</div>
						</div>
						<div class="ml-auto" v-if="'details' in log">
							<a v-if="detailIndex != logIndex" href="#" v-on:click.prevent="showDetails(logIndex)">Show Details</a>
							<a v-else href="#" v-on:click.prevent="hideDetails(logIndex)">Hide Details</a>
						</div>
					</div>
				</li>
			</ul>

			<p v-else>No activity</p>

		</template>

	</section>
</template>
<script type="text/javascript">


export default {
	name: "ActivityLog",
	props: [
		"submittedLogJson",
		"seenLogJson",
		"editingLogJson",
		"paymentsJson",
		"typeName"
	],
	data() {
		return {
			showActivityLog: false,
			detailsVisible: false,
			detailIndex: null
		}
	},
	computed: {
		activityLog() {

			let typeNameMidSentence = this.typeName.toLowerCase()
			let typeNameStartSentence = this.typeName
			if (this.typeName.toLowerCase() == 'rfi') {
				typeNameStartSentence = "RFI"
				typeNameMidSentence = "RFI"
			}

			let vm = this

			let log = []

			let submitted = []
			try {
				submitted = JSON.parse(this.submittedLogJson)
			}
			catch (Ex) {}

			let seen = []
			try {
				seen = JSON.parse(this.seenLogJson)
			}
			catch (Ex) {}

			let editing = []
			try {
				editing = JSON.parse(this.editingLogJson)
			}
			catch (Ex) {}

			let payments = []
			try {
				payments = JSON.parse(this.paymentsJson)

				payments = payments.map(entry => {
					entry.action = "payment log entry"

					return entry
				})
			}
			catch (Ex) {}

			log = seen.concat(submitted,editing,payments)

			let merged = []
			log.forEach(entry => {
				if (!("time" in entry)) {

					merged.push(entry)

				}
				else {
					let matchingTimestampIndex = merged.findIndex(mergedEntry => mergedEntry.time == entry.time)

					if (matchingTimestampIndex >= 0) {

						if (merged[matchingTimestampIndex].action == 'payment made by qbo') {
							Object.keys(entry).forEach(key => {
								if (key in entry && !(key in merged[matchingTimestampIndex]))
									merged[matchingTimestampIndex][key] = entry[key]
							})
						}
						else {
							Object.keys(entry).forEach(key => {
								if (key in entry)
									merged[matchingTimestampIndex][key] = entry[key]
							})
						}

						
					}
					else {
						merged.push(entry)
					}
				}
			})

			//normalize the objets into an activity array
			log = merged.map(item => {

				if ("time" in item) {
					if (item.action == "email opened") {
						item.icon = "fa-envelope-open"
						item.message = item.viewer_email + " opened the "+typeNameMidSentence+" email"
					}
					else if (item.action == 'payment made') { //payment entry from the editing log (superceded by the new payments log)
						item.icon = "fa-money-bill"
						item.message = "Payment of $"+item.payment_amount+" made"
					}
					else if (item.action == 'payment log entry') {
						item.icon = "fa-money-bill"
						item.message = "Payment of $"+item.amount+" made"

						if ("createdByName" in item && item.createdByName) {
							item.message += ", recorded by " + item.createdByName
						}
					}
					else if (item.action == 'payment made by qbo') {
						item.icon = "fa-money-bill"
						item.message = "Payment of $"+item.payment_amount+" made through Quickbooks Online"
					}
					else if ("viewer_email" in item) {
						item.icon = "fa-eye"
						item.message = item.viewer_email + " viewed the "+typeNameMidSentence+""
					}
					item.datetime = item.time
					
				}
				else if ("sentAt" in item) {
					item.datetime = item.sentAt
					item.icon = "fa-paper-plane"

					if ("sendList" in item) {
						let recipCount = item.sendList.length
						
						if ("sentByName" in item) 
							item.message = typeNameStartSentence+" was sent by "+item.sentByName+" to "+recipCount+" recipients"
						
						else 
							item.message = typeNameStartSentence+" was sent to "+recipCount+" recipients"

						item.details = []
						item.sendList.forEach(recip => {
							item.details.push(recip.email)
						})
					}
					else if ("markedOnly" in item && item.markedOnly) {

						if ("sentByName" in item) 
							item.message = typeNameStartSentence+" marked as sent by "+item.sentByName
						else
							item.message = typeNameStartSentence+" marked as sent"
					}
				}
				else if ("action" in item) {
					if (item.action == "finalized") 
						item.icon = "fa-lock"
					else if (item.action == "responded") {
						item.icon = "fa-reply"
						item.message = item.responderName + " responded to the " + typeNameMidSentence
					}
					else if (item.action == "de-finalized")
						item.icon = "fa-lock-open"
					else if (item.action == "processed" || item.action == "un-processed")
						item.icon = "fa-check"
					else
						item.icon = "fa-lock-open"
					
					if (!item.message && item.editedBy)
						item.message = item.editedBy.fullName + " " + item.action + " the "+typeNameMidSentence
				}
				return item
			})

			log = log.sort((a,b) => {
				if (vm.moment(a.datetime) < vm.moment(b.datetime))
					return 1
				else 
					return -1
			})

			return log

		}
	},
	methods: {
		showDetails(index) {
			this.detailsVisible = true
			this.detailIndex = index
		},
		hideDetails(index) {
			this.detailsVisible = false
			this.detailIndex = null
		}
	}
}
</script>